import React from 'react';
import { FaStar, FaRegStar } from 'react-icons/fa6';
import {
    useListFavoritesQuery,
    useStarEntityMutation,
    useUnstarEntityMutation,
} from '../../api/favorite';

interface StarToggleProps {
    entityId: string;
    entityType: 'Project' | 'Image' | 'Result';
    className?: string;
}

// Star indicator + toggle. Reads the favorites list for its type (RTK dedupes
// the request across every instance) and flips star/unstar on click.
export default function StarToggle({ entityId, entityType, className }: StarToggleProps) {
    const { data } = useListFavoritesQuery(entityType);
    const [star, { isLoading: starring }] = useStarEntityMutation();
    const [unstar, { isLoading: unstarring }] = useUnstarEntityMutation();

    // list may contain null holes for trashed/invalid favorites (app-apis#93)
    const starred = (data ?? []).filter(Boolean).some((e: any) => e.id === entityId);
    const busy = starring || unstarring;

    const toggle = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (busy) return;
        if (starred) {
            unstar({ entityId });
        } else {
            star({ entityId, entityType });
        }
    };

    return (
        <button
            type="button"
            className={`btn btn-ghost btn-xs ${className ?? ''}`}
            onClick={toggle}
            disabled={busy}
            title={starred ? 'Unstar' : 'Add to favorite'}
            aria-label={starred ? 'Unstar' : 'Add to favorite'}
        >
            {starred ? <FaStar className="text-yellow-400" /> : <FaRegStar />}
        </button>
    );
}
